// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  background: var(--bg-primary);
  padding-top: 80px;
  display: flex;
  justify-content: center;
}

.contact-container {
  max-width: 820px;
  width: 100%;
  padding: 2rem 1.5rem;
}

.contact-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
  text-align: center;
}

.contact-description {
  color: var(--text-secondary);
  text-align: center;
  margin: 0 0 2rem;
  font-size: 0.95rem;
}

.contact-help-links {
  margin-bottom: 2rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.contact-guides-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin: 0.75rem 0 1rem;
}

.contact-guide-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 10px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: inherit;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.contact-guide-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
  transform: translateY(-1px);
}

.contact-guide-icon {
  font-size: 1.25rem;
}

.contact-guide-text {
  flex: 1;
}

.contact-guide-title {
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.15rem;
}

.contact-guide-desc {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.contact-faq-link {
  font-size: 0.9rem;
  margin: 0.5rem 0 0.75rem;
}

.contact-faq-link a {
  color: var(--accent-primary);
  text-decoration: underline;
}

.contact-response-notice {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin: 0;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.form-field label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
}

.form-field input,
.form-field textarea {
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  transition: border-color 0.2s ease;
  font-family: inherit;
  resize: vertical;
}

.form-field input:focus,
.form-field textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.contact-btn {
  padding: 0.8rem 1.5rem;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
}

.contact-btn:hover:not(:disabled) {
  background: var(--accent-hover);
}

.contact-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.contact-error {
  padding: 0.75rem;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.1);
  color: var(--error);
  border: 1px solid var(--error);
  font-size: 0.85rem;
}

.contact-rate-limit {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.1);
  color: var(--warning, #d97706);
  border: 1px solid rgba(245, 158, 11, 0.4);
  font-size: 0.85rem;
}

.contact-success {
  text-align: center;
  padding: 3rem 1.5rem;
  background: var(--bg-secondary);
  border-radius: 14px;
  border: 1px solid var(--border-primary);
}

.success-icon {
  font-size: 3rem;
  color: var(--success);
  margin-bottom: 1rem;
}

.contact-success h2 {
  font-size: 1.4rem;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
}

.contact-success p {
  color: var(--text-secondary);
  margin: 0 0 1.5rem;
}

.contact-consent-notice {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
}

.contact-consent-notice a {
  color: var(--accent-primary);
  text-decoration: underline;
}

@media (max-width: 640px) {
  .contact-guides-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 500px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".contact-page {\n  background: var(--bg-primary);\n  padding-top: 80px;\n  display: flex;\n  justify-content: center;\n}\n\n.contact-container {\n  max-width: 820px;\n  width: 100%;\n  padding: 2rem 1.5rem;\n}\n\n.contact-title {\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem;\n  text-align: center;\n}\n\n.contact-description {\n  color: var(--text-secondary);\n  text-align: center;\n  margin: 0 0 2rem;\n  font-size: 0.95rem;\n}\n\n.contact-help-links {\n  margin-bottom: 2rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.contact-guides-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n  margin: 0.75rem 0 1rem;\n}\n\n.contact-guide-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 10px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: inherit;\n  text-decoration: none;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.contact-guide-card:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);\n  transform: translateY(-1px);\n}\n\n.contact-guide-icon {\n  font-size: 1.25rem;\n}\n\n.contact-guide-text {\n  flex: 1;\n}\n\n.contact-guide-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.15rem;\n}\n\n.contact-guide-desc {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.contact-faq-link {\n  font-size: 0.9rem;\n  margin: 0.5rem 0 0.75rem;\n}\n\n.contact-faq-link a {\n  color: var(--accent-primary);\n  text-decoration: underline;\n}\n\n.contact-response-notice {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.form-field label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.form-field input,\n.form-field textarea {\n  padding: 0.7rem 1rem;\n  font-size: 0.95rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  transition: border-color 0.2s ease;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.form-field input:focus,\n.form-field textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.contact-btn {\n  padding: 0.8rem 1.5rem;\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 0.5rem;\n}\n\n.contact-btn:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.contact-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.contact-error {\n  padding: 0.75rem;\n  border-radius: 8px;\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--error);\n  border: 1px solid var(--error);\n  font-size: 0.85rem;\n}\n\n.contact-rate-limit {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  background: rgba(245, 158, 11, 0.1);\n  color: var(--warning, #d97706);\n  border: 1px solid rgba(245, 158, 11, 0.4);\n  font-size: 0.85rem;\n}\n\n.contact-success {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  background: var(--bg-secondary);\n  border-radius: 14px;\n  border: 1px solid var(--border-primary);\n}\n\n.success-icon {\n  font-size: 3rem;\n  color: var(--success);\n  margin-bottom: 1rem;\n}\n\n.contact-success h2 {\n  font-size: 1.4rem;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem;\n}\n\n.contact-success p {\n  color: var(--text-secondary);\n  margin: 0 0 1.5rem;\n}\n\n.contact-consent-notice {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.contact-consent-notice a {\n  color: var(--accent-primary);\n  text-decoration: underline;\n}\n\n@media (max-width: 640px) {\n  .contact-guides-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 500px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
